import type { SettingsResponse } from '../../api/account';
import { setAccountLocale } from '../../i18n';

let current: SettingsResponse | null = null;
/** В памяти хранятся только подтверждённые настройки, без токенов и данных владельца. */
export function applyRuntimePreferences(settings: SettingsResponse) {
  current = settings;
  setAccountLocale(settings.sources.voice_preferences.lang);
  document.dispatchEvent(new CustomEvent('steos:settings', { detail: settings }));
}
export function runtimePreferences() { return current; }
